import { Platform } from 'react-native'
import { dataTypes, imageTypes } from '@adalo/constants'

import { getScaledSources } from './images'

export const formatLibraryValue = (value, prop, binding, opts) => {
  let { getAssetURL, getImageUploadsBaseURL, values } = opts

  if (value === null || value === undefined || value === '') {
    let placeholder

    // Check if the binding is an imageBinding (library image prop).
    // If so, check if there's a placeholder image.
    if (values) {
      if (
        values[prop.name] &&
        (values[prop.name].type === 'imageBinding' ||
          values[prop.name].bindingType === 'libraryProp')
      ) {
        placeholder = getPlaceholder(values[prop.name].options, getAssetURL)
      }
      // Checks for placeholder on traditional images.
      else if (
        values.image &&
        values.image.type &&
        values.image.type === 'binding'
      ) {
        // Do not return a placeholder object if the prop is an action
        if (
          prop.name === 'avatarClickActions' ||
          prop.name === 'onPress' ||
          prop.name === 'clickActions'
        ) {
          if (typeof values[prop.name] === 'object') {
            return value
          }

          return values[prop.name]
        }

        const options =
          values.image.options !== 'undefined' ? values.image.options : null
        placeholder = getPlaceholder(options, getAssetURL)

        if (placeholder) return placeholder
      }
    }

    return placeholder || value
  }

  if (prop.type === dataTypes.IMAGE) {
    // Make sure it's a binding...

    // This line checks to see if the binding is wrapped into
    // a new object of type "imageBinding". Has to do with
    // library image controls getting support for input types of url.
    // However, if the image is of type "uploaded", there won't be a deeper
    // binding, so don't look for it.
    if (
      binding &&
      binding.type === 'imageBinding' &&
      binding.imageType !== imageTypes.UPLOADED
    ) {
      binding = binding.binding
    }
    if (binding && (binding.type === 'binding' || Array.isArray(binding))) {
      if (typeof value === 'object') {
        let url = value.url

        if (!url.match(/^https:\/\//)) {
          url = `${getImageUploadsBaseURL()}/${value.url}`
        }

        url = formatURL(url)
        let fileType = value.filename.split('.')[1]

        // return gifs without any query transforms from imgix
        if (fileType === 'gif') return { uri: url, cache: 'force-cache' }

        if (Platform.OS !== 'web' && value.width && value.height) {
          let result = getScaledSources(url, value.width, value.height)

          return result
        } else if (
          value.width &&
          value.height &&
          opts.object &&
          opts.object.attributes &&
          opts.object.attributes.width &&
          opts.object.attributes.height
        ) {
          const valueArray = value.url.split('.')
          const valueType = valueArray && valueArray[valueArray.length - 1]

          // remove url paramaters if type is gif
          if (valueType && valueType === 'gif') {
            return { uri: url, cache: 'force-cache' }
          }

          let { width, height } = opts.object.attributes

          let wRatio = value.width / width
          let hRatio = value.height / height

          if (wRatio < hRatio) {
            let imageWidth = Math.min(value.width, width * 2)

            return { uri: `${url}?w=${imageWidth}`, cache: 'force-cache' }
          } else {
            let imageHeight = Math.min(value.height, height * 2)

            return { uri: `${url}?h=${imageHeight}`, cache: 'force-cache' }
          }
        } else {
          value = value.url || value
        }
      } else if (typeof value === 'string') {
        let url = formatURL(value)
        return { uri: url, cache: 'force-cache' }
      }

      return {
        uri: `${getImageUploadsBaseURL()}/${value}?orient`,
        cache: 'force-cache',
      }
    } else if (typeof binding === 'string') {
      // New else if statement. Handles when app creator inputs static
      // URL in for the image url of a library component instead of magic text
      return { uri: formatURL(binding) }
    } else {
      let assetURL = getAssetURL(value)

      if (typeof assetURL === 'number') {
        return assetURL
      }

      if (assetURL && assetURL.match('^http://')) {
        assetURL = assetURL.replace(/^http:\/\//i, 'https://')
      }

      assetURL = formatURL(assetURL)

      return { uri: assetURL, cache: 'force-cache' }
    }
  }

  return value
}

const formatURL = url => {
  let value = url.trim()
  if (value.match('base64')) {
    return value
  }
  if (!(value.match('^http://') || value.match('^https://'))) {
    value = `https://${value}`
  } else if (value.match('^http://')) {
    value = value.replace(/^http:\/\//i, 'https://').trim()
  }
  return value
}

const getPlaceholder = (imageOptions, getAssetURL) => {
  if (imageOptions) {
    const placeholderImage =
      typeof imageOptions.placeholderImage !== 'undefined'
        ? imageOptions.placeholderImage
        : null

    if (imageOptions.placeholderImageEnabled && placeholderImage) {
      let src = getAssetURL && getAssetURL(placeholderImage)

      if (typeof src === 'number') {
        return src
      }

      return {
        uri: `${src}`,
        cache: 'force-cache',
      }
    }

    return null
  } else {
    return null
  }
}
